import axiosInstance from "@/utils/axiosInstance";

export type GovernanceExceptionType =
  | "stale_assignment"
  | "stuck_submission"
  | "workload_imbalance"
  | "assignment_unresolved"
  | "escalation_cluster"
  | "locked_submission"
  | "no_available_actions"
  | "audit_anomaly"
  | "finance_verified_not_disbursed"
  | "finance_lock_conflict"
  | "finance_amount_mismatch"
  | "finance_duplicate_risk"
  | "stale_finance_state";

export type GovernanceExceptionSeverity =
  | "informational"
  | "attention"
  | "risk"
  | "anomaly"
  | "blocked";

export interface GovernanceExceptionItem {
  exception_id: string;
  submission_id: number | null;
  type: GovernanceExceptionType;
  exception_type: GovernanceExceptionType;
  severity: GovernanceExceptionSeverity;
  title: string;
  detail: string;
  status: string | null;
  age_days: number | null;
  metric_value: number | null;
  recommended_action: string | null;
  detected_at: string;
}

export interface GovernanceExceptionResponse {
  total: number;
  by_severity: Record<string, number>;
  items: GovernanceExceptionItem[];
}

export async function fetchGovernanceExceptions(params?: {
  limit?: number;
  role_scope?: string;
}): Promise<GovernanceExceptionResponse> {
  const res = await axiosInstance.get<GovernanceExceptionResponse>(
    "/governance/exceptions",
    { params }
  );
  return res.data;
}
